import { Component, Input, OnInit } from '@angular/core';
import { CalibrationRequestToExitService } from 'src/app/Service/Calibration/CalibrationRequestToExit.service';

@Component({
  selector: 'app-CalibrationRequestToExit',
  templateUrl: './CalibrationRequestToExit.component.html',
  styleUrls: ['./CalibrationRequestToExit.component.scss']
})
export class CalibrationRequestToExitComponent implements OnInit {

  @Input() inner_deivce_id: number = 0
  Token: String = ''
  
  customerName: String = ''
  code: String = ''
  expert: String = ''
  deviceName: String = ''
  deviceCode: String = ''
  deviceSerial: String = ''
  dsc: String = ''

  constructor(
    private Calibration_Service: CalibrationRequestToExitService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_Calibration_Request()
  }

  ReadData_Calibration_Request(){
    this.Calibration_Service.GetRequestToExitDetail(this.Token,this.inner_deivce_id).subscribe(
      data=>{
        this.customerName=data['customerName']
        this.code=data['code']
        this.expert=data['expert']
        this.deviceName=data['deviceName']
        this.deviceCode=data['deviceCode']
        this.deviceSerial=data['deviceSerial']
        this.dsc=data['dsc']
      }
    )
  }

}
